/**
 * newInventoryIconSingleton.js
 * Created by Destin Frasier on 05/23/19.
 */

import { IconSingleton } from '../iconSingleton';

class NewInventoryIconSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-newInventory.loaded';
        this.svgPath = `${process.env.CDN}/graphics/newInventoryIcons.svg`;
    }
}

const instance = new NewInventoryIconSingleton();
export default instance;
